module.exports = global.config = {
  product: {
    app: {
      name: "Coaching Screen System",
      version: "21.12.22",
    },
  },
};
